import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "ठीक है",
    cancel: "रद्द करें",
    loginRegister: "लॉगिन / साइन अप",
    userAgreement: "सेवा की शर्तें",
    privacyPolicy: "गोपनीयता नीति",
    notBound: "सेट नहीं",
  },
  tabbar: {
    home: "होम",
    search: "खोज",
    library: "लाइब्रेरी",
    mine: "मेरा",
    badgeLogin: "लॉगिन",
    badgeUpgrade: "अपग्रेड",
  },
  login: {
    navTitle: "लॉगिन",
    welcome: "{brand} में आपका स्वागत है",
    subtitle: "SMS से लॉगिन करें, या WeChat / QQ इस्तेमाल करें",
    subtitleGlobal: "अतिथि के रूप में तुरंत खेलें, या Google से लॉगिन करें",
    mobileLabel: "फ़ोन",
    mobilePlaceholder: "फ़ोन नंबर",
    codeLabel: "कोड",
    codePlaceholder: "SMS कोड",
    getCode: "कोड भेजें",
    resendIn: "{sec}s बाद फिर भेजें",
    agreement:
      "अपंजीकृत नंबर पर अकाउंट अपने आप बन जाता है। जारी रखने पर आप {userAgreement} और {privacyPolicy} से सहमत होते हैं",
    otherMethods: "लॉगिन के अन्य तरीके",
    guest: "अतिथि के रूप में जारी रखें",
    wechat: "WeChat से लॉगिन",
    qq: "QQ से लॉगिन",
    google: "Google के साथ जारी रखें",
    telegram: "Continue with Telegram",
    facebook: "Facebook के साथ जारी रखें",
    wechatComingSoon: "WeChat लॉगिन जल्द आ रहा है",
    qqComingSoon: "QQ लॉगिन जल्द आ रहा है",
    googleComingSoon: "Google लॉगिन जल्द आ रहा है",
    googleFailed: "Google लॉगिन विफल, कृपया दोबारा कोशिश करें",
    telegramFailed: "Telegram login failed, please try again",
    facebookComingSoon: "Facebook लॉगिन जल्द आ रहा है",
    mobileInvalid: "कृपया सही फ़ोन नंबर दर्ज करें",
    codeInvalid: "कृपया कोड दर्ज करें",
    codeSent: "कोड भेज दिया",
  },
  loginPrompt: {
    defaultMessage: "अपने गेम देखने के लिए लॉगिन करें",
  },
  settings: {
    navTitle: "सेटिंग्स",
    loginPrompt: "अकाउंट सेटिंग्स के लिए लॉगिन करें",
    nickname: "निकनेम",
    mobile: "फ़ोन",
    controller: "कंट्रोलर सेटिंग्स",
    controllerDesc: "माउस सेंसिटिविटी / राइट स्टिक / बटन स्वैप",
    about: "ऐप के बारे में",
    clearCache: "लोकल कैश साफ़ करें",
    language: "भाषा",
    editNickname: "निकनेम बदलें",
    nicknamePlaceholder: "नया निकनेम",
    nickEmpty: "निकनेम खाली नहीं रह सकता",
    nickTooLong: "निकनेम ज़्यादा से ज़्यादा 16 अक्षर",
    updated: "अपडेट हो गया",
    cacheCleared: "साफ़ हो गया, कृपया दोबारा लॉगिन करें",
    aboutTitle: "{brand} के बारे में",
    aboutVersion: "वेब वर्शन v{version}",
    aboutBody:
      "क्लाउड गेमिंग, जिससे आप कहीं भी सीधे अपने ब्राउज़र में AAA गेम खेल सकते हैं।\nसभी गेम सामग्री संबंधित पब्लिशर की संपत्ति है।",
  },
  subscription: {
    choosePlan: "एक प्लान चुनें",
    included: "क्या-क्या शामिल है",
    orderSummary: "ऑर्डर सारांश",
    total: "कुल",
    continue: "जारी रखें",
    secureNote: "सुरक्षित भुगतान · एक बार की खरीदारी",
    navTitle: "अपग्रेड",
    unlockTitle: "मेंबर लाभ अनलॉक करें",
    expired: "समाप्त",
    daysLeft: "{days} दिन बाकी",
    validUntil: "{time} तक मान्य",
    tagline: "कोई कतार नहीं, लंबे सेशन, बेहतर क्वालिटी",
    perDay: "लगभग {price}/दिन",
    recommended: "सबसे बढ़िया",
    currentLevel: "मौजूदा प्लान",
    footer:
      "यह एक बार खरीदा जाने वाला सदस्यता पास है। भुगतान की पुष्टि के बाद चुनी गई अवधि जोड़ दी जाएगी और यह अपने आप रिन्यू नहीं होगा।",
    planVipMonth: "VIP मासिक",
    planSvipMonth: "SVIP मासिक",
    perkNoQueue: "कतार से छुटकारा",
    perkDailyFree: "रोज़ 60 मिनट मुफ़्त",
    perkHd: "HD क्वालिटी",
    perkAllVip: "सभी VIP लाभ",
    perkUnlimited: "अनलिमिटेड गेम समय",
    perk4k: "4K / 60fps",
    perkSupport: "प्राथमिकता सपोर्ट",
    cnPayComingSoon:
      "वेब पर WeChat / Alipay भुगतान जल्द आ रहा है — फ़िलहाल कृपया ऐप इस्तेमाल करें",
    intlPayComingSoon: "Stripe / PayPal भुगतान जल्द आ रहा है",
    payProcessing: "भुगतान पूरा करें और यह पेज खुला रखें…",
    paySuccess: "भुगतान सफल — मेंबरशिप चालू हो गई",
    payFailed: "भुगतान विफल, कृपया दोबारा कोशिश करें",
    payCancelled: "भुगतान रद्द किया गया",
    telegramExtraTimeUnavailable: "Telegram में खेलने का समय खरीदना Stars संस्करण जुड़ने के बाद उपलब्ध होगा।",
    payUnconfirmed:
      "भुगतान की पुष्टि अभी बाकी है; अगर आपने भुगतान कर दिया है तो यह जल्द ही जुड़ जाएगा",
    payPopupBlocked:
      "भुगतान विंडो ब्लॉक हो गई — कृपया पॉप-अप की अनुमति देकर दोबारा कोशिश करें",
    loadPlansFailed: "प्लान लोड नहीं हो सके, कृपया दोबारा कोशिश करें",
    retry: "दोबारा कोशिश करें",
  },
  download: {
    nav: "Download App",
    title: "Get the Starparks app",
    subtitle: "Play Starparks on your phone and purchase membership in the app.",
    androidDescription: "The Android app is available on Google Play.",
    googlePlay: "Get it on Google Play",
    iosDescription: "The iOS app is on its way.",
    comingSoon: "Coming soon",
    membershipUnavailable: "Membership is not available yet",
    membershipAppHint: "Membership purchases are not available on this website. Please use the app to purchase a membership.",
    goToDownload: "Go to download page",
  },
  app: {
    backToDesktop: "डेस्कटॉप पर वापस",
  },
  titles: {
    download: "Download App",
    home: "होम",
    search: "खोज",
    detail: "गेम जानकारी",
    library: "लाइब्रेरी",
    category: "श्रेणी",
    mine: "मेरा",
    myGames: "मेरे गेम",
    reviews: "समीक्षाएँ",
    gameVideos: "गेमप्ले वीडियो",
    commentReplies: "कमेंट",
    saves: "सेव",
    subscription: "अपग्रेड",
    signIn: "डेली चेक-इन",
    settings: "सेटिंग्स",
    controlSettings: "कंट्रोलर सेटिंग्स",
    login: "लॉगिन",
    play: "खेल रहे हैं",
  },
  home: {
    searchPlaceholder: "गेम खोजें",
    sectionDefault: "गेम",
    allGames: "सभी गेम",
    more: "और",
    empty: "अभी यहाँ कुछ नहीं है",
    latestOnline: "नई रिलीज़",
    comingSoon: "जल्द आ रहा है",
    subscribe: "मुझे बताएँ",
    subscribed: "सब्सक्राइब किया",
    score: "रेटिंग",
    subscribeSuccess: "बुक हो गया — लॉन्च होने पर सूचित करेंगे",
  },
  nav: {
    home: "होम",
    library: "लाइब्रेरी",
    searchPlaceholder: "गेम खोजें",
    me: "मेरा",
    guest: "अतिथि",
    profile: "प्रोफ़ाइल",
    myGames: "मेरे गेम",
    dailyCheckIn: "डेली चेक-इन",
    renewMembership: "मेंबरशिप रिन्यू करें",
    upgradeMembership: "मेंबरशिप अपग्रेड करें",
    settings: "सेटिंग्स",
    switchToMobile: "मोबाइल पर स्विच करें",
    logout: "लॉग आउट",
    logoutConfirm: "क्या आप वाकई लॉग आउट करना चाहते हैं?",
    mobileVersion: "मोबाइल",
    login: "लॉगिन",
  },
  library: {
    all: "सभी",
    noMore: "बस इतना ही",
    loading: "लोड हो रहा है…",
    noData: "कोई डेटा नहीं",
    noGames: "कोई गेम नहीं",
    noUpcoming: "कोई आगामी गेम नहीं",
    emptyCategory: "इस श्रेणी में कोई गेम नहीं",
  },
  mine: {
    notLoggedIn: "लॉगिन नहीं है",
    loginSyncTip: "मेंबरशिप, फेवरेट और गेम हिस्ट्री सिंक करने के लिए लॉगिन करें",
    loginSyncTipDesktop:
      "अपनी प्रोफ़ाइल, मेंबरशिप, चेक-इन और गेम हिस्ट्री देखने के लिए लॉगिन करें",
    guest: "अतिथि",
    daysLeft: "{n} दिन बाकी",
    expired: "समाप्त",
    renewBanner: "आपका {level} {n} दिन में समाप्त हो रहा है — रिन्यू पर 30% छूट",
    membershipExpiredRenew: "आपकी मेंबरशिप समाप्त हो गई है — अभी रिन्यू करें",
    membershipExpired: "मेंबरशिप समाप्त",
    membershipDaysLeft: "मेंबरशिप के {n} दिन बाकी",
    gameTime: "गेम समय",
    minUnit: "मिनट",
    dailyCheckIn: "डेली चेक-इन",
    upgrade: "अपग्रेड",
    renew: "रिन्यू",
    upgradeMembership: "मेंबरशिप अपग्रेड करें",
    renewMembership: "मेंबरशिप रिन्यू करें",
    membership: "मेंबरशिप",
    myCollection: "मेरे फेवरेट",
    collectedGames: "सेव किए गेम",
    recentlyPlayed: "हाल में खेले",
    gameHistory: "गेम हिस्ट्री",
    settings: "सेटिंग्स",
    switchToDesktop: "डेस्कटॉप पर स्विच करें",
    accountAndPrefs: "अकाउंट और प्राथमिकताएँ",
    claimGameTime: "गेम समय कमाएँ",
    bindPhone: "फ़ोन नंबर जोड़ें",
    bindPhoneDesc: "पूरे अकाउंट में अपग्रेड करें और सभी डिवाइस पर सिंक करें",
    bindPhoneDescDesktop: "पूरे अकाउंट में अपग्रेड करें, सभी डिवाइस पर सिंक करें",
    resetGuest: "अतिथि पहचान रीसेट करें",
    resetGuestDesc: "इस अतिथि अकाउंट को साफ़ करके नए सिरे से शुरू करें",
    resetGuestDescDesktop: "नई पहचान के साथ नए सिरे से शुरू करें",
    logout: "लॉग आउट",
    myGamesTitle: "मेरे गेम",
    collectTab: "फेवरेट",
    loginViewCollect: "सेव किए गेम देखने के लिए लॉगिन करें",
    noCollect: "अभी कोई सेव किया गेम नहीं",
    loginViewHistory: "अपनी गेम हिस्ट्री देखने के लिए लॉगिन करें",
    noHistory: "हाल में कोई गेम नहीं खेला",
    weekMon: "सोम",
    weekTue: "मंगल",
    weekWed: "बुध",
    weekThu: "गुरु",
    weekFri: "शुक्र",
    weekSat: "शनि",
    weekSun: "रवि",
    alreadySignedToday: "आज चेक-इन हो चुका है",
    signSuccessReward: "चेक-इन हो गया! +{n} मिनट",
    signSuccess: "चेक-इन हो गया",
    loginJoinCheckIn: "डेली चेक-इन के लिए लॉगिन करें",
    claimed: "मिल गया",
    unclaimed: "छूट गया",
    todayDone: "आज ✓",
    today: "आज",
    dayN: "दिन {n}",
    signedToday: "आज चेक-इन किया",
    signNow: "अभी चेक-इन करें",
    checkInTip1: "मुफ़्त गेम समय पाने के लिए रोज़ चेक-इन करें।",
    checkInTip2: "छूटे दिनों की भरपाई मेक-अप पेज पर कॉइन से की जा सकती है।",
    loggedOut: "लॉग आउट हो गए",
    resetGuestConfirm:
      "इससे मौजूदा गेस्ट अकाउंट हट जाएगा और नई पहचान से नए सिरे से शुरू होगा। खरीदी गई सदस्यता, फेवरेट और इतिहास सब खो जाएंगे। जारी रखें?",
    resetGuestConfirmBtn: "रीसेट करें",
    resetting: "रीसेट हो रहा है…",
    resetDone: "रीसेट हो गया — कृपया दोबारा लॉगिन करें",
  },
  reviews: {
    recommendRate: "सिफ़ारिश",
    tooFew: "बहुत कम समीक्षाएँ",
    count: "{n} समीक्षाएँ",
    playFirst: "समीक्षा के लिए पहले गेम खेलें",
    rateThis: "खेल लिया? समीक्षा दें",
    mine: "मेरी",
    edit: "संपादित करें",
    delete: "हटाएँ",
    report: "रिपोर्ट करें",
    played: "{d} खेला",
    contentEmpty: "समीक्षा खाली नहीं हो सकती",
    editReview: "समीक्षा संपादित करें",
    editDone: "अपडेट हो गया",
    published: "समीक्षा पोस्ट हो गई",
    deleteTitle: "समीक्षा हटाएँ?",
    deleteConfirm: "यह वापस नहीं होगा। यह समीक्षा हटाएँ?",
    deleted: "हटा दी गई",
    reportTitle: "रिपोर्ट करें",
    reportConfirm: "इस सामग्री की रिपोर्ट करें? हमारी टीम समीक्षा करेगी।",
    reported: "रिपोर्ट की गई",
    deleteReplyTitle: "जवाब हटाएँ?",
    deleteReplyConfirm: "यह जवाब हटाएँ?",
    replyTo: "ने जवाब दिया",
    viewAllReplies: "सभी {n} जवाब देखें",
    loadMore: "और लोड करें",
    allReplies: "सभी जवाब ({n})",
    commentDeleted: "यह समीक्षा हटा दी गई",
    commentShielded: "यह समीक्षा छिपा दी गई",
    replyDeleted: "यह जवाब हटा दिया गया",
    replyShielded: "यह जवाब छिपा दिया गया",
  },
  detail: {
    svipRequiredMsg: "इस गेम को खेलने के लिए SVIP आवश्यक है",
    timeInsufficientMsg: "गेम समय अपर्याप्त है। कृपया पहले गेम समय खरीदें।",
    goBuy: "अभी खरीदें",
    thinkAgain: "फिर से सोचें",
    navTitle: "गेम जानकारी",
    back: "वापस",
    svipOnly: "सिर्फ़ SVIP",
    vipOnly: "सिर्फ़ VIP",
    freeMinutes: "{n} मिनट मुफ़्त",
    saveManage: "सेव",
    saveManageDesc: "पुराने सेव देखें / रिस्टोर करें और नोट जोड़ें",
    liveVideos: "गेमप्ले वीडियो",
    more: "और",
    viewAll: "सभी देखें",
    viewAllCount: "सभी {n} देखें",
    intro: "गेम के बारे में",
    screenshots: "स्क्रीनशॉट",
    controlMethod: "कंट्रोल: ",
    playerReviews: "समीक्षाएँ",
    commentCount: "{n}",
    recommend: "पसंद आया",
    notRecommend: "पसंद नहीं",
    similarGames: "मिलते-जुलते गेम",
    collect: "फेवरेट",
    collected: "फेवरेट किया",
    collectStar: "☆ फेवरेट",
    collectedStar: "★ फेवरेट किया",
    unfavorited: "फेवरेट से हटाया",
    entering: "प्रवेश हो रहा है…",
    unlockSvip: "SVIP से अनलॉक करें",
    unlockVip: "VIP से अनलॉक करें",
    startGame: "खेलें",
    reviewCount: "{n} समीक्षाएँ",
    sortHot: "टॉप",
    sortNew: "नई",
    noMore: "बस इतना ही",
    playedHours: "{n} घंटे खेला",
    report: "रिपोर्ट",
    reportTitle: "इस कमेंट की रिपोर्ट करें?",
    reportMessage: "हमारी टीम इसकी समीक्षा करेगी। रिपोर्ट करें?",
    reported: "रिपोर्ट हो गई",
    noReviews: "अभी कोई समीक्षा नहीं — पहले आप लिखें",
    writeReview: "समीक्षा लिखें",
    reviewPlaceholder: "अपना अनुभव बताएँ… (कम से कम 5 अक्षर)",
    reviewMinLength: "समीक्षा कम से कम 5 अक्षर की हो",
    reviewSubmitted: "समीक्षा सबमिट हो गई",
    publish: "पोस्ट करें",
    commentDetail: "कमेंट",
    replyCount: "{n} जवाब",
    noReplies: "अभी कोई जवाब नहीं — पहले आप दें",
    reply: "जवाब दें",
    replyToUser: "{'@'}{name} को जवाब",
    saySomething: "कुछ लिखें…",
    send: "भेजें",
    sent: "भेज दिया",
    videoCount: "{n} वीडियो",
    watchCount: "{k}k व्यूज़",
    noVideos: "अभी कोई वीडियो नहीं",
    videoUnavailable: "यह वीडियो अभी नहीं चल सकता",
    videoUnavailableDesc: "शायद यह पुराना क्लिप है जो हटा दिया गया है — कोई और आज़माएँ",
  },
  search: {
    placeholder: "गेम का नाम लिखें",
    emptyHint: "गेम के नाम या पिनयिन से खोजें",
    history: "हाल की खोज",
    clear: "साफ़ करें",
    noResults: "कोई गेम नहीं मिला",
  },
  misc: {
    savesTitle: "गेम सेव",
    savesTitleNamed: "{name} - सेव",
    savesLoginPrompt: "अपने गेम सेव देखने के लिए लॉगिन करें",
    savesActiveHeading: "चालू सेव",
    savesUnnamed: "बिना नाम का सेव",
    savesEditRemark: "नाम बदलें",
    savesEmpty: "अभी कोई क्लाउड सेव नहीं",
    savesEmptyHint: "गेम में बने सेव यहाँ अपने आप सिंक हो जाते हैं",
    savesHistory: "हिस्ट्री",
    savesCount: "{n} सेव",
    savesCurrent: "मौजूदा",
    savesCorrupted: "खराब",
    savesRestore: "रिस्टोर करें",
    savesNoHistory: "कोई सेव हिस्ट्री नहीं",
    savesFooter:
      "सेव गेम में मैन्युअल / ऑटो सेव से बनते हैं और अपने आप क्लाउड में सिंक हो जाते हैं। मैन्युअल डिलीट फ़िलहाल उपलब्ध नहीं है (गेम में सेव करते रहने पर सबसे पुराना अपने आप ओवरराइट हो जाता है)।",
    savesRemarkTitle: "सेव का नाम बदलें",
    savesRemarkPlaceholder: "इस सेव को नाम दें, जैसे \"अध्याय 1 पूरा किया\"",
    savesSave: "सेव करें",
    savesAlreadyCurrent: "यह पहले से ही मौजूदा सेव है",
    savesRestoreTitle: "सेव रिस्टोर करें",
    savesRestoreConfirm:
      "इस सेव पर रिस्टोर करें? अगली बार गेम \"{name}\" से शुरू होगा।",
    savesSwitched: "इस सेव पर स्विच हो गया",
    savesSaved: "सेव हो गया",
    ctrlNavTitle: "कंट्रोलर सेटिंग्स",
    ctrlSave: "सेव करें",
    ctrlIntro:
      "यहाँ माउस / गेमपैड का फ़ील एडजस्ट करें। कोई भी वैल्यू खाली / 0 छोड़ने पर हर गेम का सर्वर डिफ़ॉल्ट लागू होता है; बदलाव सभी गेम पर लागू होते हैं।",
    ctrlMouseSensitivity: "माउस सेंसिटिविटी",
    ctrlServerDefault: "सर्वर डिफ़ॉल्ट",
    ctrlMouseHint: "लॉक मोड में, मूवमेंट दूरी = फ़िज़िकल मूवमेंट × {n}%",
    ctrlStickSensitivity: "राइट स्टिक सेंसिटिविटी",
    ctrlStickHint:
      "FPS / एक्शन गेम में निशाना घुमाने की रफ़्तार। लेफ्ट स्टिक (मूवमेंट) पर असर नहीं पड़ता।",
    ctrlPrimaryClick: "प्राइमरी माउस बटन",
    ctrlLeftPrimary: "लेफ्ट प्राइमरी",
    ctrlRightPrimary: "राइट प्राइमरी",
    ctrlPrimaryClickHint:
      "कुछ गेम (जैसे कुछ इंडी टाइटल) डिफ़ॉल्ट रूप से राइट-क्लिक से फायर करते हैं, इसलिए स्वैप ज़रूरी है।",
    ctrlResetDefault: "रीसेट",
    ctrlSavedToast: "सेव हो गया, अगली बार से लागू होगा",
    ctrlResetToast: "सर्वर कॉन्फ़िग पर रिस्टोर हो गया",
    savesUploading: "सेव अपलोड हो रहा है — थोड़ी देर बाद फिर कोशिश करें",
    savesCheckFailed: "सेव स्थिति जांच विफल — फिर कोशिश करें",
  },
  play: {
    stageReady: "तैयार",
    queueing: "कतार में",
    queueJoining: "कतार में लग रहे हैं…",
    queueAheadPrefix: "",
    queueAheadSuffix: "खिलाड़ी आपसे आगे",
    queueEta: "लगभग {n}s",
    cancelReturn: "रद्द करके वापस जाएँ",
    back: "वापस",
    retry: "दोबारा कोशिश करें",
    goSubscribe: "अपग्रेड",
    entering: "गेम में प्रवेश",
    vipCta: "अभी प्रवेश के लिए VIP में अपग्रेड करें",
    vipPerks: "कोई कतार नहीं + HD क्वालिटी + लंबे सेशन",
    sessionExpiredHint:
      "लंबे इंतज़ार के बाद सेशन अक्सर समाप्त हो जाता है — दोबारा कतार में लगने के लिए \"दोबारा कोशिश करें\" दबाएँ",
    lineOldUser: "पुराने खिलाड़ी कतार",
    lineNewbie: "नए खिलाड़ी कतार",
    lineFast: "फास्ट-ट्रैक कतार",
    lineSvip: "SVIP कतार",
    svipRequired: "यह गेम सिर्फ़ SVIP के लिए है। कृपया पहले SVIP में अपग्रेड करें",
    stageConnectingServer: "सर्वर से कनेक्ट हो रहा है…",
    stageHandshake: "सर्वर से हैंडशेक हो रहा है…",
    stageP2pNegotiating: "P2P चैनल बन रहा है…",
    stageMediaStreaming: "मीडिया स्ट्रीम हो रहा है…",
    stageWaitingFrame: "वीडियो का इंतज़ार…",
    stageVideoTrack: "वीडियो ट्रैक मिल गया…",
    stageEntered: "कनेक्ट हो गया",
    stageConnect: "कनेक्शन",
    stageConnectedSoon: "कनेक्ट हो गया — वीडियो जल्द ही दिखेगा…",
    allocFailed: "गेम सर्वर नहीं मिल सका",
    allocFailedHttp: "आवंटन विफल (HTTP {status})",
    reenterHint: " (कृपया गेम से बाहर निकलकर दोबारा प्रवेश करें)",
    errP2pFailed: "P2P कनेक्शन विफल। कृपया अपना नेटवर्क जाँचें",
    errDisconnected: "कनेक्शन टूट गया (code={code})। कृपया दोबारा कोशिश करें",
    errStageFailed: "{stage} विफल",
    errStageFailedDetail: "{stage} विफल: {detail}",
    errConnectTimeout:
      "कनेक्शन टाइम-आउट — सर्वर तक नहीं पहुँच सके। नेटवर्क जाँचकर दोबारा कोशिश करें",
    errQueueCancelled: "सर्वर ने आपकी कतार रद्द कर दी। कृपया दोबारा कोशिश करें",
    errKicked:
      "आपका अकाउंट किसी और डिवाइस पर लॉगिन हुआ, इसलिए यह सेशन डिसकनेक्ट हो गया",
    errCannotStart: "अभी गेम शुरू नहीं हो सकता",
    registerFailed: "रजिस्ट्रेशन विफल",
  },
  game: {
    recharge: "रिचार्ज",
    tabControl: "कंट्रोल",
    tabFrame: "डिस्प्ले",
    tabVoice: "साउंड",
    controlScheme: "कंट्रोल मोड",
    hideVirtualKeys: "वर्चुअल बटन छिपाएँ",
    mouseMode: "माउस मोड",
    mouseModeTouchpad: "टचपैड",
    mouseModeDrag: "ड्रैग",
    mouseModeDirect: "डायरेक्ट",
    mouseSensitivity: "माउस सेंसिटिविटी {n}%",
    rightStickMode: "राइट स्टिक मोड",
    joyModeFixed: "फिक्स्ड",
    joyModeHalf: "हाफ स्क्रीन",
    joyModeFull: "फुल स्क्रीन",
    joyModeDrag: "ड्रैग",
    stickSensitivity: "स्टिक सेंसिटिविटी {n}%",
    customLayout: "कस्टम बटन लेआउट",
    editLayout: "लेआउट एडिट करें",
    frameComingSoon:
      "डिस्प्ले स्केलिंग / क्वालिटी स्विचिंग आगे आने वाले वर्शन में आएगी।",
    gameSound: "गेम साउंड",
    schemeFollow: "गेम के अनुसार",
    schemeGamepad: "गेमपैड",
    schemeKeyMouse: "कीबोर्ड और माउस",
    schemeTouch: "टच",
    schemeSwitchedGamepad: "गेमपैड पर स्विच हो गया",
    schemeSwitchedKeyMouse: "कीबोर्ड और माउस पर स्विच हो गया",
    schemeSwitchedFollow: "वापस गेम के अनुसार हो गया",
    modifierTitle: "मॉडिफ़ायर",
    modifierNeedUnlock: "इस मॉडिफ़ायर को अनलॉक करने के लिए खरीदना होगा",
    usageTitle: "निर्देश",
    usageEmpty: "अभी कोई निर्देश नहीं",
    gotIt: "समझ गया",
    close: "बंद करें",
    noModifiers: "कोई मॉडिफ़ायर नहीं",
    locked: "लॉक",
    needUnlock: "अनलॉक के लिए खरीदें",
    remaining: "{d} बाकी",
    use: "इस्तेमाल करें",
    quitTitle: "गेम छोड़ें",
    quitConfirm: "मौजूदा गेम छोड़ें?",
    quitConfirmBtn: "छोड़ें",
    quitCancelBtn: "खेलते रहें",
    joyNameFixed: "फिक्स्ड",
    joyNameHalfZone: "हाफ-स्क्रीन ज़ोन",
    joyNameFullFollow: "फुल-स्क्रीन फॉलो",
    joyNameDrag: "ड्रैग",
    padConnected: "🎮 गेमपैड कनेक्ट हुआ, वर्चुअल बटन छिप गए",
    padDisconnected: "गेमपैड डिसकनेक्ट हुआ, वर्चुअल बटन वापस आ गए",
    rightStickToast: "राइट स्टिक: {name}",
    noEditableLayout: "कोई एडिट करने योग्य बटन लेआउट नहीं",
    timeUsedUp: "गेम समय खत्म हो गया",
    addTimeSuccess: "समय जुड़ गया",
    submitted: "सबमिट हो गया",
    minutesShort: "{n} मिनट",
    addTime: "समय बढ़ाएँ",
    expand: "खोलें",
    collapse: "समेटें",
    physicalPadConnected: "फ़िज़िकल गेमपैड कनेक्ट हुआ",
    unmute: "अनम्यूट",
    mute: "म्यूट",
    fullscreen: "फुलस्क्रीन",
    summonKeyboard: "कीबोर्ड दिखाएँ",
    sensoryMode: "मोशन नियंत्रण",
    idleWarnTip: "लंबे समय से कोई गतिविधि नहीं। {n}s में गेम से बाहर निकलेंगे।",
    idleContinue: "जारी रखें",
    nsInputTitle: "गेम को टेक्स्ट इनपुट चाहिए",
    nsInputHint: "टेक्स्ट लिखें, फिर पुष्टि करें",
    settings: "सेटिंग्स",
    currentRemaining: "{n} मिनट बाकी",
    exchangeBeans: "बीन्स से समय एक्सचेंज करें",
    useAddTimeCard: "टाइम कार्ड इस्तेमाल करें",
  },
  drama: {
    title: "शॉर्ट ड्रामा", refresh: "रीफ़्रेश", retry: "फिर कोशिश करें", loadFailed: "ड्रामा लोड नहीं हो सका।", completed: "पूर्ण", episodes: "{n} एपिसोड", noMore: "और कुछ नहीं", loadMore: "और लोड करें", back: "वापस", episode: "एपिसोड {n}", episodesLabel: "एपिसोड", lockedTitle: "यह एपिसोड अनलॉक करें", lockedBody: "होस्ट ऐप में अनलॉक करें या रिवॉर्ड विज्ञापन देखें।", unlockEpisode: "अनलॉक करें", watchAd: "विज्ञापन देखें", adUnlocked: "एपिसोड अनलॉक हुआ", adUnavailable: "विज्ञापन उपलब्ध नहीं है।", paymentPending: "होस्ट ऐप में भुगतान पूरा करें।", paymentUnavailable: "भुगतान उपलब्ध नहीं है।", videoUnavailable: "वीडियो उपलब्ध नहीं है।",
  },
  net: {
    requestFailed: "अनुरोध विफल",
    errorWithCode: "त्रुटि {code}",
    serverError: "सर्वर त्रुटि {status}",
    timeout: "अनुरोध समय समाप्त",
    networkError: "नेटवर्क त्रुटि",
  },
  controls: {
    selectKeyFirst: "पहले कोई बटन चुनें",
    saved: "सेव हो गया",
    saveFailed: "सेव विफल",
    selected: "चुना गया: {name}",
    keyFallback: "बटन",
    hint: "जगह बदलने के लिए ड्रैग करें; साइज़ / पारदर्शिता / क्रिया बदलने के लिए टैप करें",
    size: "साइज़ {pct}%",
    opacity: "पारदर्शिता {pct}%",
    operation: "क्रिया",
    opPress: "दबाएँ",
    opDrag: "ड्रैग",
    opLock: "लॉक",
    delete: "हटाएँ",
    addKey: "बटन जोड़ें",
    reset: "रीसेट",
    save: "सेव करें",
    addHiddenKey: "छिपा बटन जोड़ें",
    noHiddenKeys: "कोई छिपा बटन नहीं",
  },
};

export default messages;
